<template>

  <GraphResidues class="boxgraphInboxsection" />

  <div class="about">
    <h1>This is an about page</h1>
  </div>

  <div>
    <tabs :options="{ useUrlFragment: false }" @clicked="tabClicked" @changed="tabChanged" nav-item-class="nav-item">
        <tab name="First tab">
            Link  doc : <a href= "https://www.npmjs.com/package/vue3-tabs-component">https://www.npmjs.com/package/vue3-tabs-component</a>
        </tab>
        <tab name="Second tab">
            This is the content of the second tab
        </tab>
        <tab name="Disabled tab" :is-disabled="true">
            This content will be unavailable while :is-disabled prop set to true
        </tab>
        <tab id="oh-hi-mark" name="Custom fragment">
            The fragment that is appended to the url can be customized
        </tab>
        <tab prefix="<span class='glyphicon glyphicon-star'></span> " 
             name="Prefix and suffix" 
             suffix=" <span class='badge'>4</span>">
            A prefix and a suffix can be added
        </tab>
    </tabs>
</div>


<LoaderDiv />




</template>


<script>

import LoaderDiv from '@/components/LoaderDiv.vue';
//import GraphCoord from '@/components/GraphCoord.vue';
import GraphResidues from '@/components/GraphResidues3.vue'



export default {
  name: 'AboutView',
  components: {
    LoaderDiv,
    //GraphCoord,
    GraphResidues

},


mounted() {







 
}



};


</script>

<style>
.tabs-component-tabs {
  border: 0;
  align-items: stretch;
  display: flex;
  justify-content: flex-start;
  margin-bottom: -1px;
}

</style>
